import styled, {keyframes, css} from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DivSelect = styled.div`
  input:focus {
    border: none !important;
    box-shadow: none !important;
    height: 38px !important;
  }

  .sc-gKAblj .eIGroG {
    height: 20px;
  }

  .css-b62m3t-container {
    height: 50px;
  }

  .css-v68sna-control {
    height: 50px;
  }

  .css-1fdsijx-ValueContainer {
    height: 20px;
  }

  .css-qbdosj-Input {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: start;
  }
`;

export const LateralEsquerda = styled.div`
  background-color: #BD207B;
  height: 100vh;
  display: none;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding-right: 20px;
  @media only screen and (min-width: 601px) {
    display: flex;
  }
  h5{
    color: white;
    text-transform: capitalize;
  }
`;

export const LateralDireita = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoginForm = styled.div`
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  max-width:300px;
  padding: 30px;
  max-height: 550px;
  width: 100%;
`;

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

export const SubmitButton = styled.button.attrs(props => ({
  type: 'submit',
  disabled: props.loading === 'true'
}))`
  background: #61098A;
  border: 1px solid #61098A;
  border-radius: 100px;
  color: #ffffff;
  display: inline-block;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  letter-spacing: 0.4px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.4px;
  line-height: normal;
  padding: 8px 24px;
  text-align: center;
  width: 100%;

  &[disabled]{
      cursor: not-allowed;
      opacity: 0.6;
  }

  :focus {
    background: #61098A;
    opacity: 0.8;
  }

  ${props => (props.loading === 'true') && css`
      svg{
          animation: ${rotate} 2s linear infinite;
      }
  `}

  span{
    color: #fff;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 60px;
    padding-left: 60px;
  }

`;

export const Form = styled.form`
  margin-top: 0.5rem;
  width: 100%;
  p {
    display:  ${props => ( (props.error!=="") ? "block" : "none")};
    color: #ff3333;
    margin-bottom: 15px;
    border: 1px solid #ff3333;
    padding: 10px;
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  input, select{
        width:100%;
        border: 1px solid #eee;
        padding: 10px 15px;
        border-radius: 4px;
        font-size: 16px;
        margin-bottom: 10px;
    }
`;

export const ComboEmpresa = styled.select`
  display:  ${props => ( (props.mostrarEmpresas==='true') ? "block" : "none")};

`;
